module.exports = __webpack_public_path__ + "img/loading.242b400d.svg";